import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../../../services/apiService';
import { mapState } from 'vuex';
import { isNullOrEmpty } from '../../../../../utils/vuex';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
export default {
  name: 'CoreDtwinStateBridgeSmartservice',
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: true
    },
    bridgeConfig: {
      type: Object,
      required: true
    },
    // is this an 'edit', 'create', or mass-variable- 'import'?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    }
  },
  data: function data() {
    return {
      loadingVariables: false,
      searchItem: '',
      // the retrieved variables for the search-item
      variables: null,
      selectedVariable: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    tableProps: function tableProps() {
      return {
        headers: [{
          sortable: true,
          text: this.$i18n_t('Common.description'),
          value: 'description',
          align: 'left'
        }, {
          sortable: true,
          text: 'Data Point',
          value: 'datapoint',
          align: 'left'
        }, {
          sortable: true,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
          value: 'value',
          align: 'left'
        }, {
          sortable: true,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
          value: 'unit',
          align: 'left'
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [20, 50, {
            text: this.$i18n_t('Common.all'),
            value: -1
          }]
        }
      };
    },
    variableRules: function variableRules() {
      var _this = this;

      return [function (v) {
        return !!v && /^([0-9A-F]{16})$/gi.exec(v.trim()) !== null || _this.$i18n_t('Bridges.Smartservice.euiRule');
      }];
    },
    formIsValid: function formIsValid() {
      return !isNullOrEmpty(this.selectedVariable) && this.selectedVariable.length > 0;
    }
  }),
  watch: {
    searchItem: function searchItem(val) {
      if (!(this.bridgeConfig || {}).configId) {
        return;
      } else if (!val || val.trim() === '') {
        return;
      }

      this.fetchVariables();
    },
    bridgeConfig: function bridgeConfig(val) {
      var _this2 = this;

      if (val) {
        this.$nextTick(function () {
          var deviceInput = _this2.$refs.niotaDevice.$el.querySelector('input');

          deviceInput.focus();
        });
        this.emitSelection();
      }
    },
    selectedVariable: function selectedVariable() {
      this.emitSelection();
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.mode !== 'create' && this.mode !== 'import') {
      this.selectedVariable = [{
        datapoint: get(this.lclModel, 'properties.binding.options.variable')
      }]; // configId, devEui, datapoint

      if (get(this.bridgeConfig, 'configId') && get(this.lclModel, 'properties.binding.options.identifier')) {
        this.searchItem = get(this.lclModel, 'properties.binding.options.identifier');
        return this.fetchVariables().then(function (variables) {
          _this3.variables = variables;

          if (variables) {
            _this3.selectedVariable = [variables.find(function (v) {
              return v.datapoint === get(_this3.lclModel, 'properties.binding.options.variable');
            })].filter(function (v) {
              return v;
            });
          }
        });
      }
    }
  },
  methods: {
    emitSelection: function emitSelection() {
      this.$emit('bridge-binding-changed', {
        variable: get(this.selectedVariable, '[0].description'),
        value: get(this.selectedVariable, '[0].value'),
        valueType: get(this.selectedVariable, '[0].unit')
      });
    },
    fetchVariables: function fetchVariables() {
      var _this4 = this;

      this.variables = null; // A81758FFFE052B42

      if (/^([0-9A-F]{16})$/gi.exec(this.searchItem.trim())) {
        this.loadingVariables = true;
        return ApiService.bridgeReadCmdGetDatapointsByEUI(get(this.bridgeConfig, 'configId'), this.searchItem.trim()).then(function (variables) {
          if (!isArray(get(variables, 'data'))) {
            throw new Error(get(variables, 'errorMessage') || _this4.$i18n_t('Error.unknown'));
          }

          _this4.variables = get(variables, 'data');
          return _this4.variables;
        }).catch(function (error) {
          if (get(error, 'response.status') === 401) {
            // user has no permission to execute bridge commands
            // so emit the no-permission event here to trigger the edit-dialog to be closed
            _this4.$emit('no-permission', _this4.$i18n_t('DigitalTwin.DigitalTwin.states.noPermissionError'));

            return;
          }

          var errorMessage = get(error, 'response.data.message', error.message);
          var errorOutput = _this4.$i18n_te("Error.".concat(errorMessage)) ? _this4.$i18n_t("Error.".concat(errorMessage)) : _this4.$i18n_t(errorMessage);

          _this4.$snack(errorOutput, 'error');

          _this4.variables = null;
          console.error(error);
        }).finally(function () {
          _this4.loadingVariables = false;
        });
      }

      return Promise.resolve(null);
    },
    saveState: function saveState() {
      this.lclModel.properties.binding.options.identifier = this.selectedVariable[0].devEui;
      this.lclModel.properties.binding.options.variable = this.selectedVariable[0].datapoint;
    }
  }
};